import * as React from 'react';

import ActionBar from '../../actionBar/components/ActionBar';
import { ActionBarProps } from '../../actionBar/components/ActionBar';

import Modul, {ModuleType} from '../../module/Modul';
import ModulWithRedux from '../../module/ModulWithRedux';

import { DiyFeedbackSubmit } from '../../feedback/DiyFeedbackSubmit';

import TabOptions from '../../actionBar/interfaces/TabOptions';

import l10n from '../../util/l10n';

import ClearIcon from 'material-ui/svg-icons/content/clear';
import SaveIcon from 'material-ui/svg-icons/content/save';

import { autoprefixer } from "../../material-ui/autoprefixer";

import IconTextButton from '../../custom-components/icon-text-button/IconTextButton';
import ModulSection from "../../module/ModulSection";

type Handler = () => void;
/* tslint:disable:no-empty */
const NOOP: Handler = function() {};
/* tslint:enable:no-empty */

interface ModuleActionBarProps extends React.Props<ModuleActionBar> {
    open: boolean;
    undoEnabled: boolean;
    redoEnabled: boolean;
    moduleId: number;
    currentTab: number;
    onTabChange(payload: {nextTab: number}): any;
}

export const MODULE_ACTION_BAR_ELEMENT_ID = "diy-module-action-bar";

export default class ModuleActionBar extends React.Component<ModuleActionBarProps, {}> {

    private lastModule: Modul;
    private lastTabs: TabOptions[];

    render() {
        const actionBarProps = this.props.open
            ? this.getOpenActionBarProps()
            : this.getClosedActionBarProps()
            ;

        return (
            <div>
                <ActionBar elementId={MODULE_ACTION_BAR_ELEMENT_ID} {...actionBarProps} />
            </div>
        );
    }

    private getButtons(cancelHandler: Handler, saveHandler: Handler) {
        const styles = this.getStyles();
        const module: Modul = Modul.getInstance(this.props.moduleId);

        if (module instanceof ModulSection) {
            return (
                <div style={styles.buttons}>
                    <IconTextButton
                        Icon={<SaveIcon />}
                        text={l10n("section.actionBar.buttons.done.label")}
                        style={styles.saveButton}
                        isPrimary={true}
                        onTouchTap={() => {
                            // Not using "this" because module is re-rendered and it will replace
                            // the module instance
                            const module = Modul.getInstance(this.props.moduleId) as ModulSection;
                            module.close(true, false, true, false);
                            module.emitCloseKpi();
                        }}
                        dataTestId="section-edit-done"
                        isDisabled={saveHandler === NOOP}
                    />
                </div>
            );
        } else {
            return (
                <div style={styles.buttons}>
                    <IconTextButton
                        Icon={<ClearIcon />}
                        text={l10n('cancel')}
                        style={styles.cancelButton}
                        onTouchTap={cancelHandler}
                        dataTestId="action-bar-btn-cancel"
                        isDisabled={cancelHandler === NOOP}
                        isSecondary={true}
                    />
                    <IconTextButton
                        Icon={<SaveIcon />}
                        text={l10n('save')}
                        style={styles.saveButton}
                        isPrimary={true}
                        onTouchTap={saveHandler}
                        dataTestId="action-bar-btn-save"
                        isDisabled={saveHandler === NOOP}
                    />
                </div>
            );
        }
    }

    private getFeedbackContext(module: Modul) {
        if (module.getModuleType() === ModuleType.SECTION) {
            let data = (module as ModulSection).getData();
            return `module.section.${data.base}.${data.variant}`;
        } else {
            let parentSection: ModulSection = module.getParentSection();
            if (parentSection) {
                let data = parentSection.getData();
                return `module.section.${data.base}.${data.variant}/module.${module.getModuleType()}`;
            } else {
                return `module.${module.getModuleType()}`;
            }
        }
    }

    private getOpenActionBarProps(): ActionBarProps {
        const module: Modul = Modul.getInstance(this.props.moduleId);

        let tabs: TabOptions[] = null;
        // XXX in some scenarios (modules that use CKEditor, if first operation is paste on Firefox)
        // re-rendering with a
        // new tabOptions got from module will break
        // due to some weird bug, but using a cached tabOptions fixes the issue
        if (this.lastModule === module && this.lastTabs) {
            tabs = this.lastTabs;
        } else {
            tabs = module.getActionBarTabs();
            this.lastTabs = tabs;
        }

        let undoHandler: Handler = null;
        let redoHandler: Handler = null;
        if (module instanceof ModulWithRedux && module.hasUndoRedo) {
            undoHandler = module.undoHandler;
            redoHandler = module.redoHandler;
        }

        this.lastModule = module;

        return {
            open: true,
            onHelpClick: module.openHelpArticle.bind(module),
            buttons: this.getButtons(
                () => module.close(true, true, false, true),
                () => module.onSaveBtnClick()
            ),
            autoScrollElement: module.getContentElement(),
            tabs,
            currentTab: this.props.currentTab,
            hasFeedbackbutton: true,
            feedbackFeatureName: module.textLabel,
            feedbackContext: this.getFeedbackContext(module),
            onFeedbackSubmit: DiyFeedbackSubmit,
            onUndoClick: undoHandler,
            onRedoClick: redoHandler,
            undoEnabled: this.props.undoEnabled,
            redoEnabled: this.props.redoEnabled,
            onTabChange: v => {
                this.props.onTabChange({nextTab: v});
                module.onActionBarTabChange(v);
            }
        };
    }

    private getClosedActionBarProps(): ActionBarProps {
        return {
            open: false,
            onHelpClick: NOOP,
            buttons: this.getButtons(NOOP, NOOP),
            autoScrollElement: null,
            tabs: null,
            hasFeedbackbutton: true,
            feedbackFeatureName: null,
            feedbackContext: null,
            onFeedbackSubmit: DiyFeedbackSubmit,
            onUndoClick: null,
            onRedoClick: null,
            undoEnabled: false,
            redoEnabled: false
        };
    }

    private getStyles() {
        return {
            buttons: Object.assign(autoprefixer({
                display: 'flex' }), {
                marginLeft: 12
            }),
            cancelButton: {
                marginRight: 4
            },
            saveButton: {
                minWidth: 72
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module-action-bar/components/ModuleActionBar.tsx
 **/